import React from 'react';

import { ServiceMode } from 'generated/graphql-gateway';
import { IconTitle, SectionTitle, SubHeading } from 'pages/order-confirmation/styled';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { getHeadingForServiceMode } from 'utils/service-mode';

const ServiceModeHeading = ({ serviceMode }: { serviceMode: ServiceMode }) => {
  const isFastLaneEnabled = useFlag(LaunchDarklyFlag.ENABLE_FAST_LANE_DRIVE_THRU);
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );

  const serviceModeHeadingConfig = getHeadingForServiceMode(
    isFastLaneEnabled,
    isMobileOrderForDriveThruLaneEnabled,
    serviceMode
  );

  return (
    serviceModeHeadingConfig && (
      <SubHeading focusable>
        <IconTitle variant={serviceModeHeadingConfig.icon} />
        <SectionTitle>{serviceModeHeadingConfig.heading}</SectionTitle>
      </SubHeading>
    )
  );
};
export default ServiceModeHeading;
